<template>
    <div class="w3-container" style="padding-top: 40px;padding-bottom:16px; margin-top:40px" v-bind:style="'height:'+  (screenHeight-40) +'px;'">
        <Toolbar  
            :click-add="showAdd"
            :click-edit="showEdit"
            :click-delete="showDelete"
            :click-refresh="showRefresh"
            :set-filter="loadDataSearch"
            :status-print="false"
            :data   = "recs"
            :fields = "json_fields"
            type    = "xls"
            name    = "Kunjungan.xls"
        />
        <div class="w3-container" style="padding: 0px;">
            <div id="wrapper">
                <div id="content">
                    <div class="w3-hide-small w3-hide-medium" id="boundary">
                        <table id="header" cellpadding="4" cellspacing="0" border="0" style="width:100%;">
                            <thead>
                                <tr class="w3-theme-l2">
                                    <th width="50px">No. </th>
                                    <th v-for="fl in filterByShow" :width="fl.width" :key="fl.name" class="">{{fl.name}}</th>
                                    <th width="1px"></th>
                                </tr>
                            </thead>
                        </table>
                    </div>
                    <div class="scrlt-y" v-bind:style="'height:'+  (screenHeight-165) +'px;'">
                        <table class="w3-table w3-table-all">
                            <tr v-for="(dt, index) in recs" :key="dt.ts_id" class="w3-hover-pale-blue w3-small cursor" v-on:dblclick="showEdit(dt, index)" :class="index == selectedRow ?'w3-pale-blue':''">
                                <td class="w3-hide-large" v-on:click="setKlikRow(index, dt)">
                                    <div class="w3-col s4 m2 w3-theme-l5">
                                        <i :class="index == selectedRow ?'fa fa-caret-right':''"></i>ID
                                    </div>
                                    <div class="w3-col s8 m10 w3-theme-l4">
                                        : {{dt.ts_id}}
                                    </div>
                                    <div class="w3-col s4 m2 w3-theme-l5">Nama</div>
                                    <div class="w3-col s8 m10 w3-theme-l4">
                                        : {{dt.ts_name}}
                                    </div>
                                    <div class="w3-col s4 m2 w3-theme-l5">Level</div>
                                    <div class="w3-col s8 m10 w3-theme-l4">
                                        : {{dt.ts_level | setLevel}}
                                    </div>
                                    <div class="w3-col s4 m2 w3-theme-l5">Status</div>
                                    <div class="w3-col s8 m10 w3-theme-l4" v-html="setStatus(dt.ts_status)">
                                    </div>
                                </td>
                                <td width="50px" class="w3-hide-small w3-hide-medium w3-border-right">
                                    <i :class="index == selectedRow ?'fa fa-caret-right':''"></i>&nbsp;{{dt.idx}}
                                </td>
                                <td v-on:click="setKlikRow(index, dt)" :width="findObjFind('width','ts_id')" class="w3-center w3-hide-small w3-hide-medium w3-border-right">
                                    {{dt.ts_id}}
                                </td>
                                <td v-on:click="setKlikRow(index, dt)" :style="'width:'+findObjFind('width','ts_name')" class="w3-hide-small w3-hide-medium w3-border-right">
                                    {{dt.ts_name}}
                                </td>
                                <td v-on:click="setKlikRow(index, dt)" :style="'width:'+findObjFind('width','ts_level')" class="w3-center w3-hide-small w3-hide-medium w3-border-right">
                                    {{dt.ts_level | setLevel}}
                                <td v-on:click="setKlikRow(index, dt)" :style="'width:'+findObjFind('width','ts_status')" class="w3-border-right">
                                    <div style="position: relative;" :style="'width:' + findObjFind('width','ts_status')">
                                        <span v-html="setStatus(dt.ts_status)"></span>
                                        <div v-show="index == selectedRow" style="position: absolute; top: -6px; right: 0px; text-align:center;" class="w3-opacity-off">
                                            <button title="Tampilkan Kunjungan" style="padding: 5px 7px 5px 7px; margin-right:1px;" class="w3-btn w3-circle w3-tiny w3-theme-d3" v-on:click="showKunjungan(dt, index)"><i class="fa fa-search w3-large"></i></button>
                                        </div>
                                    </div>
                                </td>
                            </tr>                                            
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <!-- pagging -->
        <div style="height: 35px;bottom: 25px;">
            <div class="w3-bar w3-center w3-theme" style="height: 38px;position: absolute;bottom: 0;left: 0px;">
                <a :class="pages.halaman == 1 ?'dsb':''" class="w3-bar-item w3-button" @click="first()" href="#">First</a>
                <a :class="pages.halaman == 1 ?'dsb':''" class="w3-bar-item w3-button" @click="prev()" href="#">«</a>
                <a class="w3-bar-item w3-button w3-theme-l4" href="#">Page {{pages.halaman}} sd {{pages.ttlhalaman}}</a>
                <a :class="pages.halaman == pages.ttlhalaman ?'dsb':''" class="w3-bar-item w3-button" @click="next()" href="#">»</a>
                <a :class="pages.halaman == pages.ttlhalaman ?'dsb':''" class="w3-bar-item w3-button" @click="last()" href="#">Last</a>
                <a class="w3-bar-item w3-button w3-border-left w3-right" href="#">Rec {{pages.ttlrec}}</a>
            </div>
        </div>
        <div id="modal-form" class="w3-modal scrl-y">
            <div class="w3-modal-content w3-animate-zoom w3-card-4 w3-round-large" style="max-width:600px;top: -40px;">
            <header class="w3-container w3-theme-d3 round-top-large"> 
                <span onclick="document.getElementById('modal-form').style.display='none'" 
                class="w3-button w3-display-topright w3-round-large">&times;</span>
                <h5><i class="fa fa-windows"></i>&nbsp; Add / Edit data</h5>
            </header>
            <div class="w3-container">
                <form class="w3-container" id="frmGdg" v-on:submit.prevent="saveData" autocomplete="off">
                    <div class="w3-row" style="margin-top:5px;">
                        <div class="w3-col l3 m3 s12 w3-right-align w3-hide-small" style="padding-top: 5px;padding-right: 5px">
                            <label for="ts_id">{{findObjFind('name','ts_id')}} :</label>
                        </div>
                        <div class="w3-col l9 m9 s12">
                            <input ref="ts_id" readonly type="text" class="w3-input w3-small w3-round-large" id="ts_id" :placeholder="findObjFind('name','ts_id')" v-model="rec.ts_id">
                        </div>
                    </div>
                    <div class="w3-row" style="margin-top:5px;">
                        <div class="w3-col l3 m3 s12 w3-right-align w3-hide-small" style="padding-top: 5px;padding-right: 5px">
                            <label for="ts_name">{{findObjFind('name','ts_name')}} :</label>
                        </div>
                        <div class="w3-col l9 m9 s12">
                            <input ref="ts_name" required type="text" class="w3-input w3-small w3-round-large" id="ts_name" :placeholder="findObjFind('name','ts_name')" v-model="rec.ts_name">
                        </div>
                    </div>
                    <div class="w3-row" style="margin-top:5px;">
                        <div class="w3-col l3 m3 s12 w3-right-align w3-hide-small" style="padding-top: 5px;padding-right: 5px">
                            <label for="ts_password">{{findObjFind('name','ts_password')}} :</label>
                        </div>
                        <div class="w3-col l9 m9 s12" style="position: relative;">
                            <input v-model="rec.password" class="w3-input w3-round-large w3-small" :type="lihat?'text':'password'" :placeholder="findObjFind('name','ts_password')">
                            <button v-on:click="lihat=!lihat" type="button" class="w3-button w3-text-black w3-round w3-small" style="position: absolute;top: 0;right: 0;"><i class="fa" :class="lihat?'fa-eye':'fa-eye-slash'"></i></button>
                        </div>
                    </div>
                    <div class="w3-row" style="margin-top:5px;">
                        <div class="w3-col l3 m3 s12 w3-right-align w3-hide-small" style="padding-top: 5px;padding-right: 5px">
                            <label for="ts_level">{{findObjFind('name','ts_level')}} :</label>
                        </div>
                        <div class="w3-col l9 m9 s12">
                            <select v-model="rec.ts_level" class="w3-select w3-border w3-white w3-round-large w3-small" style="width: 100%;" required>
                                <option class="w3-white" v-for="option in userlevel" v-bind:value="option.value" :key="option.value">
                                    {{ option.text }}
                                </option>
                            </select>
                        </div>
                    </div>
                    <div class="w3-row" style="margin-top:5px;">
                        <div class="w3-col l3 m3 s12 w3-right-align w3-hide-small" style="padding-top: 5px;padding-right: 5px">
                            <label for="ts_status">&nbsp;</label>
                        </div>
                        <div class="w3-col l9 m9 s12">
                            <label class="container w3-small">{{findObjFind('name','ts_status')}}
                                <input v-model="rec.ts_status" type="checkbox" true-value="T" false-value="F">
                                <span class="checkmark"></span>
                            </label>
                        </div>
                    </div>
                </form>
            </div>
            <footer class="w3-container w3-theme-d1"  style="margin-top: 15px;">
                <h6 class="w3-right">
                <button form="frmGdg" class="w3-small w3-btn w3-ripple w3-white w3-round" type="submit"><i class="fa fa-save"></i> Save</button>
                <button type="button" class="w3-small w3-btn w3-ripple w3-red w3-round" onclick="document.getElementById('modal-form').style.display='none'"><i class="fa fa-close"></i> Close</button>
                </h6>
            </footer>
            </div>
        </div>
        <div id="modal-kunjungan" class="w3-modal scrl-y">
            <div class="w3-modal-content w3-animate-zoom w3-card-4 w3-round-large" style="max-width:900px;top: -40px;">
                <header class="w3-container w3-theme-d3 round-top-large"> 
                    <span onclick="document.getElementById('modal-kunjungan').style.display='none'" 
                    class="w3-button w3-display-topright w3-round-large">&times;</span>
                    <h5><i class="fa fa-windows"></i>&nbsp; Kunjungan Sales</h5>
                </header>
                <div class="">
                    <div class="w3-bar w3-theme-l1 tabMenu w3-small">
                        <button class="w3-bar-item w3-button tablink" @click="tab=1" :class="tab==1 ? ' w3-light-grey' : ''"><i class="fa fa-calendar">&nbsp;</i> Harian</button>
                        <button class="w3-bar-item w3-button tablink" @click="tab=2" :class="tab==2 ? ' w3-light-grey' : ''"><i class="fa fa-calendar">&nbsp;</i> Bulanan</button>
                    </div>
                    <div class="w3-row w3-light-gray" v-if="tab==1">
                        <div class="w3-row-padding w3-margin-bottom w3-margin-top">
                            <form class="w3-container w3-small" id="frmKunjunganHari" v-on:submit.prevent="getKunjunganHari" autocomplete="off"  style="margin-bottom: 10px;">
                                <div class="w3-row" style="margin-top:5px;">
                                    <div class="w3-col l8">
                                        <div class="w3-col l2 m2 s2 w3-right-align w3-hide-small" style="padding-top: 5px;padding-right: 5px">
                                            <label>
                                                Start :
                                            </label>
                                        </div>
                                        <div class="w3-col l4 m4 s4" style="position: relative;">
                                            <input required type="text" class="w3-input w3-small w3-round-large" id="k_start" placeholder="Tanggal" v-model="krec.k_start">
                                            <transition name="calendar-fade">
                                                <date-picker @close="showdate.k_start = false" v-if="showdate.k_start" v-model="krec.k_start"></date-picker>
                                            </transition>
                                            <button v-on:click="showdate.k_start=true" type="button" class="w3-btn w3-small w3-round-large w3-white" style="position: absolute; top: 0px; right: 0px;"><i class="fa fa-calendar"></i></button>
                                        </div>
                                        <div class="w3-col l2 m2 s2 w3-right-align w3-hide-small" style="padding-top: 5px;padding-right: 5px">
                                            <label>
                                                End :
                                            </label>
                                        </div>
                                        <div class="w3-col l4 m4 s4" style="position: relative;">
                                            <input required type="text" class="w3-input w3-small w3-round-large" id="k_end" placeholder="Tanggal" v-model="krec.k_end">
                                            <transition name="calendar-fade">
                                                <date-picker @close="showdate.k_end = false" v-if="showdate.k_end" v-model="krec.k_end"></date-picker>
                                            </transition>
                                            <button v-on:click="showdate.k_end=true" type="button" class="w3-btn w3-small w3-round-large w3-white" style="position: absolute; top: 0px; right: 0px;"><i class="fa fa-calendar"></i></button>
                                        </div>
                                    </div>
                                    <div class="w3-col l4 w3-center">
                                        <button type="submit" class="w3-btn w3-theme w3-round w3-small" form="frmKunjunganHari"><i class="fa fa-search"></i>&nbsp; Show</button>
                                    </div>
                                </div>
                            </form>
                            <div class="w3-container">
                                <table class="w3-table w3-bordered w3-striped w3-border w3-small w3-hoverable" id="reckunjunganhari">
                                    <thead>
                                        <tr class="w3-theme-l3">
                                            <th class="w3-border-right">Name</th>
                                            <th class="w3-border-right">Location</th>
                                            <th class="w3-border-right">Date & Time</th>
                                        </tr>
                                    </thead>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div class="w3-row w3-light-gray" v-if="tab==2">
                        <div class="w3-row-padding w3-margin-bottom w3-margin-top">
                            <form class="w3-container w3-small" id="frmKunjunganBulan" v-on:submit.prevent="getKunjunganBulan" autocomplete="off" style="margin-bottom: 10px;">
                                <div class="w3-row" style="margin-top:5px;">
                                    <div class="w3-col l8">
                                        <div class="w3-col l5 m5 s2 w3-right-align w3-hide-small" style="padding-top: 5px;padding-right: 5px">
                                            <label>
                                                Bulan :
                                            </label>
                                        </div>
                                        <div class="w3-col l5 m5 s5" style="position: relative;">
                                            <select class="w3-select w3-round-large w3-white" v-model="krec.k_date">
                                                <option value=""></option>
                                                <option value="01">Januari</option>
                                                <option value="02">Februari</option>
                                                <option value="03">Maret</option>
                                                <option value="04">April</option>
                                                <option value="05">Mei</option>
                                                <option value="06">Juni</option>
                                                <option value="07">Juli</option>
                                                <option value="08">Augustus</option>
                                                <option value="09">September</option>
                                                <option value="10">Oktober</option>
                                                <option value="11">November</option>
                                                <option value="12">Desember</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="w3-col l4">
                                        <button type="submit" class="w3-btn w3-theme w3-round w3-small" form="frmKunjunganBulan"><i class="fa fa-search"></i>&nbsp; Show</button>
                                    </div>
                                </div>
                            </form>
                            <div class="w3-container">
                                <table class="w3-table w3-bordered w3-striped w3-border w3-small w3-hoverable" id="reckunjunganbulan">
                                    <thead>
                                        <tr class="w3-theme-l3">
                                            <th class="w3-border-right">Name</th>
                                            <th class="w3-border-right">Location</th>
                                            <th class="w3-border-right">Date & Time</th>
                                        </tr>
                                    </thead>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
/* eslint-disable */
import Config from '@/conf/Config.js';
import axios from "axios";
import Toolbar from "@/components/Toolbar.vue";
import DatePicker from "@/components/DatePicker.vue";
import moment from "moment";

// import "jquery/dist/jquery.min.js";
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import "datatables.net-buttons/js/dataTables.buttons.js";
import "datatables.net-buttons/js/buttons.html5.js";
import $ from "jquery";

export default {
    // head: {
    //     title: {
    //       inner: 'Main'
    //     }
    // },
    name : 'Kunjungan',
    components: {
        Toolbar,
        DatePicker
    },
    data() {
        return {
            lihat : false,
            tab : 1,
            showdate :{k_start:false, k_end:false},
            screenHeight : 0,
            selectedRow : -1,
            rec: {},
            krec : {
                k_start : moment(new Date()).format('YYYY-MM-DD'),
                k_end : moment(new Date()).format('YYYY-MM-DD'),
                k_date : ""
            },
            harirecs : [],
            bulanrecs : [],
            recs: [],
            userlevel: [
                { text: 'SALES', value: '00' },
                { text: 'MASTER', value: '01' },
                { text: 'STAPEL', value: '10' },
                { text: 'ADMIN', value: '11' }
            ],
            pages : {halaman : 1, batas : 0, ttlhalaman : 0, ttlrec:0, limit:Config.perpage, search:''},
            filters : {
            	operator : 'AND',
                fields :[
                        {fieldFind : '', key : 'ts_id', type: 'text', name : 'ID', filter : true, width : '50px', grid : true},
                        {fieldFind : '', key : 'ts_name', type: 'text', name : 'Name / Username', filter : true, width : 'auto', grid : true},
                        {fieldFind : '', key : 'ts_password', type: 'text', name : 'Password', filter : true, width : 'auto', grid : false},
                        {fieldFind:'', key : 'ts_level', type: 'select', name : 'Level', filter : true, width : '80px', grid : true, valueFind: [{key:'T',label:'Aktif'},{key:'F',label:'Tidak Aktif'}]},
                        {fieldFind:'', key : 'ts_status', type: 'select', name : 'Status', filter : true, width : '50px', grid : true, valueFind: [{key:'T',label:'Aktif'},{key:'F',label:'Tidak Aktif'}]},
                ],
                find : []   
            },
            /**Untuk transfer excel*/
            json_fields : {
                'ID' : 'ts_id',
                'NAME' : 'ts_name',
                'KETERANGAN' : 'ts_keterangan'
            },
        }
    },
    methods : {
        findObjFind(key, val){
            return this.findObj(this.filters.fields,'key',val)[key];
        },
        findField(val){
            return this.findObj(this.fieldRules, 'field',val);
        },
        findObj(obj, key, value) {
            let ketemu = 0;
            for (var pkey in obj) {
                if (obj[pkey][key] == value) {
                    break;
                } else {
                    ketemu++;
                }
            }
            if(obj[ketemu]!=undefined){
                return obj[ketemu];
            }else
                return null;
        },
        first(){
            let self = this;
            self.pages.halaman = 1;
            self.loadData();
        },
        prev(){
            let self = this;
            self.pages.halaman = self.pages.halaman - 1;
            self.loadData();
        },
        next(){
            let self = this;
            self.pages.halaman = self.pages.halaman + 1;
            self.loadData();
        },
        last(){
            let self = this;
            self.pages.halaman = self.pages.ttlhalaman;
            self.loadData();
        },
        setKlikRow(index, dt){
            let self = this;
            self.selectedRow = index;
            dt.password = '';
            self.rec = Object.assign({}, dt);
        },
        loadData(){
            this.screenHeight = window.innerHeight;
            let self = this;
            self.selectedRow = -1;
            self.rec = {};
            let params = {
                pfunction:'show',
                limit: self.pages.limit,
                page: self.pages.halaman,
                search: self.pages.search
            }
            axios.post("sales/ApiSales.php",params).then(function (response) {
                let idx = (self.pages.limit*self.pages.halaman)-self.pages.limit+1;
                self.pages.ttlrec = parseFloat(response.data.ttlrec);
                self.pages.ttlhalaman = Math.ceil(parseFloat(response.data.ttlrec)/self.pages.limit);
                response.data.rec.map(function(val){
                    val['idx'] = idx;
                    idx++;
                });
                self.recs = response.data.rec;
            });
        },
        showRefresh(){
            this.pages.search = "";
            this.loadData();
        },
        loadDataSearch(filter){
            this.pages.search = filter;
            this.loadData();
        },
        async showAdd() {
            let self = this;
            self.selectedRow = -1;
            self.stsAdd = true;
            let key = await axios.post("admin/ApiGetId.php",{
                pfunction : 'getIdTable',
                tablename : 'tb_sales'
            });
            self.rec = {
                ts_id : key.data+1,
                ts_name : '',
                ts_password : '',
                password : '',
                ts_level : '00',
                ts_status : 'T'
            };
            document.getElementById("modal-form").style.display = "block";
            setTimeout(function(){
                document.getElementById('ts_name').focus();
            },500);
        },
        showKunjungan(dt,index){
            document.getElementById("modal-kunjungan").style.display = "block";
            $('#reckunjunganhari').DataTable().clear();
            setTimeout(function(){
                $('#reckunjunganhari').DataTable().destroy();
            },500);
        },
        showEdit(){
            let self = this;
            if (self.selectedRow < 0) {
                this.$toast.error('pilih gudang.!');
                return false;
            }else{
                this.stsAdd = false;
                document.getElementById('modal-form').style.display='block';
                setTimeout(function(){
                    document.getElementById('ts_name').focus();
                },500);
            }
        },
        saveData(event){
            var self = this;
            if (self.stsAdd == true) {
                self.rec.pfunction = "add";
            }else{
                self.rec.pfunction = "edit";
            }
            self.rec['userentry'] = localStorage.username;
            axios.post("sales/ApiSales.php",self.rec).then(function (response) {
                if(response.data.success == true){
                    self.$toast.success(response.data.msg);
                    if (self.stsAdd) {
                        self.recs.splice(0, 0, self.rec);
                    }else{
                        self.recs[self.selectedRow] = self.rec;
                    }
                    document.getElementById('modal-form').style.display='none';
                    self.selectedRow = -1;
                }else{
                    self.$toast.error(response.data.msg);
                }
            });
            event.preventDefault();
            return false;
        },
        getKunjunganHari(event){
            let self = this;
            document.getElementById('idLoading').style.display='block';
            let vparams = {
                sales : self.rec.ts_id,
                start : self.krec.k_start,
                end : self.krec.k_end,
                pfunction : 'showbyidhari'
            }
            axios.post("sales/ApiSalesLocation.php",vparams).then(function (response) {
                document.getElementById('idLoading').style.display='none';
                self.harirecs = response.data.rec;
                $('#reckunjunganhari').DataTable({
                    destroy: true,
                    responsive: true,      
                    scrollX: true,
                    deferRender: true,
                    autoWidth: false,
                    data : self.harirecs,
                    columns: [
                        {"data": "ts_name"},
                        {"data": "tc_name"},
                        {"data": "sl_date"}
                    ],
                    columnDefs: [
                    ],
                    dom: 'lfBrtip',
                    buttons: [
                        { 
                            extend: 'csvHtml5', text: 'Export',
                            className: 'w3-btn w3-blue w3-tiny w3-round',                        
                        }
                    ],
                });
            });
            event.preventDefault();
            return false;
        },
        getKunjunganBulan(event){
            let self = this;
            document.getElementById('idLoading').style.display='block';
            let vparams = {
                sales : self.rec.ts_id,
                bulan : self.krec.k_date,
                pfunction : 'showbyidbulan'
            }
            axios.post("sales/ApiSalesLocation.php",vparams).then(function (response) {
                document.getElementById('idLoading').style.display='none';
                self.bulanrecs = response.data.rec;
                $('#reckunjunganbulan').DataTable({
                    destroy: true,
                    responsive: true,      
                    scrollX: true,
                    deferRender: true,
                    autoWidth: false,
                    data : self.bulanrecs,
                    columns: [
                        {"data": "ts_name"},
                        {"data": "tc_name"},
                        {"data": "sl_date"}
                    ],
                    columnDefs: [
                    ],
                    dom: 'lfBrtip',
                    buttons: [
                        { 
                            extend: 'csvHtml5', text: 'Export',
                            className: 'w3-btn w3-blue w3-tiny w3-round',                        
                        }
                    ],
                });
            });
            event.preventDefault();
            return false;
        },
        showDelete() {
            var self = this;
            if (self.selectedRow < 0) {
                this.$toast.error('pilih gudang.!');
                return false;
            }else{
                swal(
                    {
                        title: "Yakin Ingin Menghapus Data ..!",
                        text: "Data Yang sudah di hapus tidak akan bisa dikembalikan",
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#DD6B55",
                        confirmButtonText: "Ya, Hapus Data",
                        cancelButtonText: "Tidak, Batal Hapus",
                        closeOnConfirm: false,
                        closeOnCancel: true,
                    },
                    function(isConfirm) {
                        if (isConfirm) {
                            var vparams = { 
                                ts_id : self.rec.ts_id,
                                pfunction : "delete"
                            };
                            axios.post("sales/ApiSales.php",vparams).then(function (response) {
                                if (response.data.success == true) {
                                    swal({title: "Hapus..!",text: "Data Sudah terhapus",timer: 1000,type: "success"});
                                    self.$delete(self.recs, self.selectedRow);
                                }else{
                                    swal({title: "Delete",text: "Gagal delete data",type: "error",html: true});
                                }
                            });
                        }
                    }
                );
            }
        },
        setStatus(dt) {
            if (dt === "T") {
                return "<div class='w3-green w3-center w3-round' style='width:50px;margin-top:0px;'>Active</div>";
            } else {
                return "<div class='w3-red w3-center w3-round' style='width:50px;margin-top:0px;'>In Active<div>";
            }
        },
        setInit() {
            let self = this;
            axios.post("sales/ApiSales.php",{
                pfunction : 'setcustomer'
            }).then(function (response) {
                self.customers = response.data.rec;
            });
        }
    },
    filters: {
        toRp(value) {
            return `${Intl.NumberFormat("de-DE").format(value)}`;
        },
        pNumber(num) {
            var x = num.replace(/\D/g, '').match(/(\d{0,4})(\d{0,4})(\d{0,4})/);
            return !x[2] ? x[1] : '(' + x[1] + ')-' + x[2] + (x[3] ? '' + x[3] : '');
        },
        setLevel(dt) {
            if (dt == "11") {
                return "ADMIN";
            } else if (dt == "10") {
                return "STAPEL";
            } else if (dt == "01") {
                return "MASTER";
            } else {
                return "SALES";
            }
        }
    },
    watch: {
        // 'tab': function(dt){
        //     if (dt == 1) {
        //         $('#recmarketing').DataTable().destroy();
        //     }else{        
        //         $('#recstock').DataTable().destroy();
        //     }
        // }
    },
    computed :{
        filterByShow(){
            return  this.filters.fields.filter(event => {
                return event.grid == true;                
            });
        }
    },
    mounted(){
        this.screenHeight = window.innerHeight;
        // this.setInit();
        this.loadData();
    }
};
</script>